// Yup
import * as yup from 'yup';

// Helpers
import { isValidCNPJ } from 'helpers/cnpj';

interface PaymentMethodSchemaOptions {
  // False for a PSP reached without mTLS (Cielo), whose PIX config has no client certificate.
  certificateRequired?: boolean;
}

/**
 * The payment-method form schema.
 */
const buildPaymentMethodSchema = ({
  certificateRequired = true,
}: PaymentMethodSchemaOptions = {}) => {
  const certificateField = certificateRequired
    ? yup.string().required('Campo obrigatório')
    : yup.string();

  return yup.object().shape({
    type: yup.mixed().oneOf(['PIX', 'BOLETO', 'CARD']),
    bank: yup.mixed().oneOf(['SICREDI', 'BB', 'SANTANDER', 'CAIXA', 'CIELO']),
    status: yup
      .number()
      .required('Campo obrigatório')
      .typeError('Valor deve ser um número'),
    PaymentCardConfig: yup.object().shape({
      username: yup.string().required('Campo obrigatório'),
      password: yup
        .string()
        .required('Campo obrigatório')
        .typeError('Campo obrigatório'),
      description: yup.string().required('Campo obrigatório'),
      min: yup
        .number()
        .required('Campo obrigatório')
        .typeError('Valor deve ser um número')
        .min(0, 'Valor muito pequeno')
        .max(5000, 'Valor muito grande!'),
      max: yup
        .number()
        .required('Campo obrigatório')
        .typeError('Valor deve ser um número')
        .min(0, 'Valor muito pequeno')
        .max(5000, 'Valor muito grande!'),
      antifraudUsername: yup
        .string()
        .required('Campo obrigatório')
        .typeError('Campo obrigatório'),
      antifraudPassword: yup
        .string()
        .required('Campo obrigatório')
        .typeError('Campo obrigatório'),
      antifraudId: yup
        .string()
        .required('Campo obrigatório')
        .typeError('Campo obrigatório'),
    }),
    PaymentPixConfig: yup.object().shape({
      expiration: yup
        .number()
        .required('Campo obrigatório')
        .typeError('Campo obrigatório'),
      description: yup.string().required('Campo obrigatório'),
      operator: yup.string().required('Campo obrigatório'),
      name: yup.string().required('Campo obrigatório'),
      min: yup
        .number()
        .required('Campo obrigatório')
        .typeError('Valor deve ser um número')
        .min(0, 'Valor muito pequeno')
        .max(5000, 'Valor muito grande!'),
      key: yup.string().required('Campo obrigatório'),
      username: yup.string().required('Campo obrigatório'),
      password: yup.string().required('Campo obrigatório'),
      certificate: certificateField,
      certificatePassword: certificateField,
    }),
    PaymentBoletoConfig: yup.object().shape({
      expiration: yup
        .number()
        .required('Campo obrigatório')
        .typeError('Campo obrigatório'),
      description: yup.string().required('Campo obrigatório'),
      min: yup
        .number()
        .required('Campo obrigatório')
        .typeError('Campo obrigatório'),
      authToken: yup.string().required('Campo obrigatório'),
      key: yup.string().required('Campo obrigatório'),
      username: yup
        .string()
        .required('Campo obrigatório')
        .typeError('Campo obrigatório'),
      password: yup
        .string()
        .required('Campo obrigatório')
        .typeError('Campo obrigatório'),
      certificate: yup.string().required('Campo obrigatório'),
      certificatePassword: yup.string().required('Campo obrigatório'),
      agency: yup.string().required('Campo obrigatório'),
      place: yup.string().required('Campo obrigatório'),
      cedente: yup.string().required('Campo obrigatório'),
      name: yup.string().required('Campo obrigatório'),
      document: yup
        .string()
        .required('Campo obrigatório')
        .typeError('Campo obrigatório')
        .test('Digite um CNPJ válido', 'Digite um CNPJ válido', (cnpj) =>
          isValidCNPJ(cnpj),
        ),
      account: yup.string().required('Campo obrigatório'),
      number: yup
        .string()
        .required('Campo obrigatório')
        .typeError('Campo obrigatório'),
      convenio: yup.string().required('Campo obrigatório'),
    }),
  });
};

const paymentMethodSchema = buildPaymentMethodSchema();

export default paymentMethodSchema;
export { paymentMethodSchema, buildPaymentMethodSchema };
